export const BASE_API = 'https://sisurat.herokuapp.com'
export const API_URI = BASE_API + '/graphql'
export const STORAGE_URI = BASE_API + '/storage'
export const PRINT_URI = BASE_API + '/print/surat_keluar.html'
